export default {
	id: 'SIMPLE_PREMIUM_1M_49_1M_14_99',
	providers: {
		paltaMap: {
			USD: 'simple_premium_1m_49_1m_14_99_usd', // It's a fake price point for analytics
		},
		primer: 'prd_2Uz9rmoFOIc7',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'month',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 30,
		priceMap: {
			USD: 14.99,
		},
		originalPriceMap: {
			USD: 49,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 49,
		},
	},
}
